// extracted by mini-css-extract-plugin
export default {"title":"_06d59a8620","bld":"_0c34a2481a"};